import axios from 'axios';
import { verifyRecaptcha } from '@js/utils/Recaptcha';
import { createCookie, getKeyEmailFormData } from '@js/utils/SessionCookies';

const manageOverlay = () => {
    const overlay = document.querySelector('.OverlayReglette');
    const buttonOpen = document.querySelectorAll('.js-openOverlayReglette');
    const buttonClose = document.querySelectorAll('.js-closeOverlayReglette');

    const toggleOverlay = () => {
        if (overlay) {
            overlay.classList.toggle('open');
            toggleFormSuccess(false);
            resetErrorLabel();

            window.dataLayer.push({
                pageTheme: 'REGLETTE'
            });

            //block scroll
            document.body.classList.toggle('hasOverlayOpen');
        }
    };

    if (buttonOpen) {
        buttonOpen.forEach((btn) => {
            btn.addEventListener('click', async () => {
                toggleOverlay();
                await axios.get('/open_api/nutrition/order-reglette-modal-open');
            });
        });
    }

    if (buttonClose) {
        buttonClose.forEach((btn) => {
            btn.addEventListener('click', () => {
                toggleOverlay();
            });
        });
    }
};

const manageErrorLabel = (value, type) => {
    if (value) {
        const labelError = document.querySelector(`#error-${type}`);

        labelError.innerHTML = value;
    }
};

const resetErrorLabel = () => {
    document.querySelectorAll('.js-errorLabel').forEach((errorLabel) => {
        errorLabel.innerHTML = '';
    });

    const alert = document.querySelector('.js-alertReglette');

    if (!alert) return;

    alert.classList.add('hidden');
    alert.innerHTML = '';
};

const toggleFormSuccess = (isSuccess = true) => {
    let CLASS_TO_REPLACE = 'hidden';
    let CLASS_REPLACED_BY = 'flex';

    const formContainer = document.querySelector('.js-regletteOverlayFormContainer');
    const successElement = document.querySelector('.js-regletteOverlayFormSuccess');

    if (!isSuccess) {
        CLASS_TO_REPLACE = 'flex';
        CLASS_REPLACED_BY = 'hidden';
    }

    formContainer.classList.toggle('hidden', isSuccess);
    successElement.classList.replace(CLASS_TO_REPLACE, CLASS_REPLACED_BY);
};

const manageRegletteForm = () => {
    const formReglette = document.querySelector('.js-regletteForm');

    if (formReglette) {
        formReglette.addEventListener('submit', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            resetErrorLabel();

            if (!document.querySelector('.js-regletteForm').reportValidity())
                return;

            const form = e.currentTarget;

            try {
                await verifyRecaptcha(form);
            } catch (error) {
                const alert = document.querySelector('.js-alertReglette');

                if (!alert) return;

                alert.classList.remove('hidden');
                alert.innerHTML = error.message;

                return;
            }

            const formData = form ? new FormData(form) : new FormData();

            const retrivedKey = getKeyEmailFormData(formData);

            if (retrivedKey) {
                createCookie(formData.get(retrivedKey), '_realtimeasset');
            }

            const data = {}

            for (const [key, value] of formData.entries()) {
                const match = key.match(/\[([^\]]+)\]$/);
                if (match) {
                    const input = match[1];
                    data[input] = value;
                }
            }
            console.log(data);
            try {
                const response = await axios.post('/open_api/nutrition/order-reglette', data);

                if (response) {
                    window.dataLayer.push({
                        event: 'REGLETTE',
                        action: 'submit'
                    });

                    toggleFormSuccess();
                }
            } catch (error) {
                const { errors, error: errorMessage } = error.response.data;

                if (errors) {
                    const errorsList = [
                        { value: errors.firstname, type: 'firstname' },
                        { value: errors.lastname, type: 'lastname' },
                        { value: errors.email, type: 'email' },
                        { value: errors.phone, type: 'zipcode' },
                        { value: errors.address, type: 'address' },
                        { value: errors.city, type: 'city' }
                    ];

                    errorsList.forEach((error) =>
                        manageErrorLabel(error.value, error.type)
                    );
                }

                if (errorMessage) {
                    const alert = document.querySelector('.js-alertReglette');

                    if (!alert) return;

                    alert.classList.remove('hidden');
                    alert.innerHTML = errorMessage;
                }
            }
        });
    }
};

const ServiceReglette = () => {
    manageOverlay();
    manageRegletteForm();
};

export default ServiceReglette;
